import { ArrowDownToLine, ArrowUpFromLine, Boxes } from "lucide-react";

const BUSINESS_ITEMS = [
  {
    icon: ArrowDownToLine,
    title: "Import",
    testId: "about-business-import",
    text: "RKG NATURALS supports international product sourcing and import-related business coordination according to customer and market requirements.",
  },
  {
    icon: ArrowUpFromLine,
    title: "Export",
    testId: "about-business-export",
    text: "We source and supply Indian agricultural and natural products to international buyers with a focus on quality, reliable supply and professional service.",
  },
  {
    icon: Boxes,
    title: "Wholesale",
    testId: "about-business-wholesale",
    text: "We support bulk sourcing and supply requirements for wholesalers, businesses and commercial buyers according to product availability and buyer requirements.",
  },
];

export const AboutBusiness = () => {
  return (
    <section data-testid="about-business" className="bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 py-16 sm:py-20">
        <h2 className="font-heading text-2xl sm:text-3xl font-bold text-[#042D1F] mb-10">Business</h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">
          {BUSINESS_ITEMS.map(({ icon: Icon, title, testId, text }) => (
            <div key={title} data-testid={testId} className="rounded-xl border border-[#E2E8F0] p-6">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-[#0B4F37]/10 text-[#0B4F37] mb-4">
                <Icon className="h-5 w-5" strokeWidth={1.8} />
              </span>
              <h3 className="font-heading text-lg font-semibold text-[#0B4F37] mb-2">{title}</h3>
              <p className="text-sm text-slate-600 leading-relaxed">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
